import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  text: 'Social proof description with',
  boldText: 'highlighted number'
}, getTestId('OfferStripWidgetContainer'));